import { lazy } from 'react';

const ContactPage = lazy(() => import('../pages/Contact.page'));

const ContactRoutes = [
    {
        path: '/contact',
        element: <ContactPage />,
        layout: 'default',
        isAuthReq: true,
    },
];

export { ContactRoutes };
